<div [ngClass]="{'white' : variant==='white'}"
     class="work-ui-logo">
  @if (context === 'default') {
    <img [src]="environment.tenantLogoPath" alt="{{environment.tenantCompany}} Logo">
  }
  @if (context === 'office') {
    <img [src]="environment.tenantOfficeLogoPath" alt="{{environment.tenantCompanyCommonName}} Office Logo">
  }
</div>
